export default {
  message: {
    "error": "Hata! Bir şeyler yanlış gitti.",
    "Sorrysomeerrorsoccurred": "Beklenmedik bir hata oluştu. Dili değiştirmeyi veya uygulamadan çıkıp yeniden başlatmayı deneyebilirsiniz.",
    "quit": "Çıkış",
    "language": "Dil",
    "Youcanchangethelanguagehere": "Dili burada değiştirebilirsiniz!",
    "current": "Mevcut",
    "home": "Anasayfa",
    "friends": "Arkadaşlar",
    "wallet": "Cüzdan",
    "aboutus": "Hakkımızda",
    "Sharewithfriends": "Arkadaşlarla paylaş",
    "copyFailure": "Kopyalama Hatası",
    "copySuccess": "Kopyalama Başarılı",
    "Claimreward": "Ödülü topla",
    "DailyLogin": "Günlük Giriş",
    "noInvitationsYet": "Henüz Davetiyeniz Yok",
    "LoadMore": "Daha Fazla Yükle",
    "WatchAD": "Reklam İzle",
    "continue": "Devam Et",
    "Congratulations": "Tebrikler",
    "MyFriends": "Arkadaşlarım",
    "Invitefriends": "Arkadaşları davet et",
    "Invitepremiumfriends": "Premium arkadaşları davet et",
    "DailyTasks": "Günlük görevler",
    "inviteDesc": "Her davet ettiğiniz arkadaş için +{num} ${name}",
    "DailyTasksDesc": "Görevleri tamamlayarak daha fazla airdrop elde et",
    "SponsorsandPartners": "Sponsorlar ve Ortaklar",
    "Receivingwallet": "Ödül cüzdanı",
    "Enterwalletaddress": "{name} cüzdan adresini girin",
    "Claim": "Topla",
    "Booster": "Destekleyici",
    "RentPeriod": "Kiralama Süresi",
    "days30": "30 gün",
    "Dailyprofit": "Günlük kazanç",
    "Totalprofit": "Toplam kazanç",
    "Quantity": "Miktar",
    "RentPrice": "Kiralama Fiyatı",
    "RentMiner": "Madenci Kirala",
    "Insufficient": "Yeterli davetli yok",
    "InsufficientMsg": "Daha fazla aksesuar kazanmak için {num} arkadaş davet etmelisiniz.",
    "Settings": "Ayarlar",
    "copyid": "Kimliği Kopyala",
    "UpgradeSuccessfully": "Başarıyla Yükseltildi",
    "Name": "İsim",
    "userinfo": "Kullanıcı bilgisi",
    "disconnect": "Bağlantıyı Kes",
    "Startmining": "Madenciliğe Başla",
    "Welcome": "{name}'ye Hoş Geldiniz",
    "Withdrawal": "Çekim",
    "Minimumamount": "Minimum miktar",
    "Networkfee": "Ağ ücreti",
    "Enteramount": "İşlem miktarını girin",
    "Submit": "Gönder",
    "MinimumTip": "Çekilecek miktar çok küçük. Minimum çekim miktarı: {num}",
    "MaximumTip": "Yetersiz miktar, maksimum çekebileceğiniz miktar: {num}",
    "SubmittedTip": "Gönderildi, işlenmesi 30-60 çalışma günü sürecektir",
    "WithdrawStatus": "Durum",
    "Submissiontime": "Gönderim zamanı",
    "WithdrawAwaitTip": "* 30-60 çalışma günü sürmesi tahmin edilmektedir. Daha fazla arkadaş davet etmek inceleme sürecini hızlandırabilir.",
    "Processing": "İşleniyor",
    "Amount": "Miktar",
    "Numberoffriends": "Arkadaş sayısı: {now}/{limit}",
    "InviteTip": "İlk çekiminizi yapmak için {limit} arkadaşınızı madencilik uygulamasına davet etmeniz gerekiyor.",
    "openonphone": "Bu bağlantıyı telefonunuzda açın.",
    "claimTip": "Alınacak miktar çok küçük. Alınacak minimum miktar: {num}",
    "WalletBalance": "Cüzdan Bakiyesi",
    "Withdraw": "Para Çek",
    "SetWalletAddress": "Cüzdan Adresini Belirle",
    "WithdrawalRecord": "Çekim Kaydı",
    "Norecords": "Kayıt yok",
    "Whatis": "{name} nedir?",
    "All": "Tümü",
    "save": "Kaydet",
    "successWithdrawal": "Tarama başarılı {num}",
    "secondsago": "{time} saniye önce",
    "Loading": "Yükleniyor...",
    "PaymentConfirming": "İşlem Durumu Kontrol Ediliyor...",
    "Check": "Kontrol et",
    "CheckFail": "İşlem tamamlanmadı. Lütfen 5 saniye sonra tekrar kontrol edin.",
    "Addname": "Adınıza '{name}' ekleyin",
    "Restattcheck": "Kontrol etmek için uygulamayı yeniden başlatın",
    "Copyname": "'{name}' kopyala",
    "SubmissionFailed": "Gönderim başarısız oldu, lütfen daha sonra tekrar deneyin",
    "WithdrawalReview": "Çekim incelemesi",
    "WebWithdrawAwaitTip": "* 24-48 saat sürmesi tahmin edilmektedir. Daha fazla arkadaş davet etmek inceleme sürecini hızlandırabilir.",
    "Success": "Başarılı",
    "Rejection": "Reddi",
    "WebSubmittedTip": "Gönderildi, en kısa sürede işleyeceğiz.",
    "select_payment_method": "Ödeme yöntemini seçin",
    "total_amount": "Toplam miktar",
    "next_step": "Sonraki adım",
    "creating_order": "Sipariş oluşturuluyor...",
    "order_created": "Sipariş oluşturuldu",
    "order_status": "Sipariş durumu",
    "order_id": "Sipariş ID'si",
    "order_amount": "Sipariş miktarı",
    "order_status_desc": "Sipariş durumu açıklaması",
    "payment_cancelled": "Ödeme iptal edildi",
    "opening_payment": "Ödeme açılıyor...",
    "payment_success": "Ödeme başarılı",
    "payment_failed": "Ödeme başarısız oldu",
    "payment_pending": "Ödeme beklemede",
    "payment_processing": "Ödeme işleniyor",
    "create_order_failed": "Sipariş oluşturma başarısız oldu",
    "creating_ton_order": "TON siparişi oluşturuluyor...",
    "check_payment_status": "Ödeme durumunu kontrol etme...",
    "use_ton_payment": "TON ödemesi kullan",
    "connect_wallet": "Cüzdanı bağla",
    "start_transaction": "İşleme başla",
    "address": "Adres",
    "amount_ton": "Miktar TON",
    "copy": "Kopyala",
    "comment_memo": "Açıklama notu",
    "comment_memo_desc": "Lütfen açıklama notunu girin",
    "comment_memo_placeholder": "Açıklama notasını girin",
    "amount": "Miktar",
    "wallet_address": "Cüzdan adresi",
    "you_can_choose_to_connect_wallet_to_pay": "Ödemek için cüzdanı bağlamayı seçebilirsiniz",
    "or_manually_transfer_to_the_above_address": "Ya da yukarıdaki adrese manuel transfer yapın (miktar ve not tam olarak aynı olmalıdır)",
    "transaction_success": "İşlem başarılı",
    "transaction_failed": "İşlem başarısız oldu",
    "transaction_error": "İşlem hatası",
    "transaction_status": "İşlem durumu",
    "transaction_id": "İşlem ID'si",
    "transaction_amount": "İşlem miktarı",
    "transaction_status_desc": "İşlem durumu açıklaması",
    "miner_detail": "Madenci detayları",
    "rent_period": "Kiralama süresi",
    "days": "{days} gün",
    "daily_yield": "Günlük getiri",
    "total_yield": "Toplam getiri",
    "invite_friends": "Arkadaşları davet et",
    "price": "Fiyat",
    "rent": "Kiralama",
    "free_claim": "Ücretsiz ödül al",
    "redeem": "İade et",
    "buy": "Kiralama",
    "invite_friends_not_enough": "Yeterli arkadaş daveti yok",
    "redeem_success": "İade başarılı",
    "redeem_failed": "İade başarısız oldu",
    "rent_success": "Kiralama başarılı",
    "rent_failed": "Kiralama başarısız oldu",
    "TotalPower": "Toplam Güç",
    "MaxQuantity": "Maksimum değere ulaşıldı",
    "Running": "Çalışıyor",
    "Stop": "Dur",
    "Withdrawalunlock": "Çekim açma",
    "Close": "Kapat",
    "Delivering": "Gönderiliyor",
    "Duetothelargenumber": "Alicilerin çokluğu nedeniyle, airdrop'unuzun 15-20 iş günü içinde ulaşması bekleniyor",
    "WithdrawalunlockTip": "Çekimi açmak için {num} davet edilen arkadaşa ihtiyacınız var, görevleri tamamlayın/cüzdanları bağlayın",
    "mining_title": "Robot",
    "Upgrade": "Yükselt",
    "partner": "Ortak",
    "faq": "Sıkça Sorulan Sorular",
    "task": "Görev",
    "OpenRobot": "Robotu Aç",
    "MyRobot": "Robotum",
    "Level": "Seviye",
    "Commission": "Komisyon",
    "DirectFriends": "Doğrudan Arkadaşlar",
    "Feedback": "Geri Bildirim",
    "Pleaseenteryouremailaddress": "Lütfen e-posta adresinizi girin",
    "Inputfeedbackcontent": "Geri bildirim içeriğini girin",
    "Submitfeedback": "Geri bildirimi gönder",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Geri bildirim başarıyla gönderildi, değerli geri bildiriminiz için teşekkür ederiz",
    "Feedbacksubmissionfailed,pleaseretriy": "Geri bildirim gönderimi başarısız oldu, lütfen tekrar deneyin",
    "Addressformaterror": "Adres format hatası",
    "Readclipboardfailed": "Panicboard okumada hata",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Bugün zaten geri bildirim verdiniz, lütfen yarın geri dönün",
    "Record": "Kayıt",
    "Newuserguidance": "Hoşgeldin Turu'nu Görüntüle",
    "Usetonwallet": "TON cüzdanını kullan",
    "Reward": "Ödül",
    "Connectwallet": "Cüzdanı bağla",
    "Notconnected": "Bağlı değil",
    "Disconnect": "Bağlantıyı kes",
    "AboutTAI": "Token Ayrıntıları",
    "WithdrawalRecordDesc": "Çekim kaydı",
    "StartAItrading": "AI ticaretine başla",
    "Next": "Sonraki",
    "Start": "Başla",
    "WithdrawalSuccess": "Çekim başarılı",
    "WithdrawalFail": "Çekim başarısız",
    "Max": "Maks",
    "WithdrawalRecords": "Çekim Kayıtları",
    "Commissionrules": "Komisyon kuralları",
    "Mycommission": "Komisyonum",
    "Shop": "Mağaza",
    "BuyDifferentAIrobots": "Tarayıcıları daha hızlı taramak için hesaplama cihazları ile yükseltin!",
    "CurrentRunningAIrobots": "Mevcut çalışan AI robotları",
    "DailyProfit": "Günlük kâr",
    "Buy": "Satın al",
    "ValidityPeriod": "Geçerlilik süresi",
    "Days": "Gün",
    "Price": "Fiyat",
    "APY": "APY",
    "NoRobot": "Hesaplama gücü yok",
    "RemainingTime": "Kalan zaman",
    "InviteandEarn": "Davetiye gönder ve kazan",
    "InvitDec": "Arkadaşlarını AI ticaretine davet et ve birlikte USDT komisyonları ile airdrop tokenleri kazan!",
    "ShareToGroups": "Gruplara paylaş",
    "Select_payment_method": "Ödeme yöntemi seçin",
    "twa_pay_tip_with_memo": "Lütfen adresin, miktarın ve notun transfer için tutarlı olduğundan emin olun.",
    "twa_pay_tip": "Lütfen adresin ve miktarın transfer için doğru olduğundan emin olun.",
    "twa_pay_tip_placeholder": "Yorum notunu girin",
    "twa_pay_tip_placeholder_with_memo": "Not ile yorum notunu girin",
    "twa_pay_tip_placeholder_without_memo": "Not olmadan yorum notunu girin",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Not ile yorum notunu girin",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Not olmadan yorum notunu girin",
    "realtime_ai": "Gerçek Zamanlı AI Ticareti",
    "check_transaction_status": "İşlem durumunu kontrol et",
    "transaction_wait": "İşlem devam ediyor. Uygulamadan çıkabilirsiniz. İşlem tamamlandığında sizi bilgilendirecek bir mesaj alacaksınız.",
    "Pleaseenteravalidemailaddress": "Lütfen geçerli bir e-posta adresi girin",
    "max_robot_tip": "Satın alma limiti aşıldı — ticarete devam etmek için başka bir plan deneyin!",
    "connectFailure": "Cüzdan bağlantısı başarısız",
    "connectSuccess": "Cüzdan bağlantısı başarılı",
    "PayNow": "Şimdi Öde",
    "min_withdrawal_amount": "Minimum çekim tutarı {num} {coin_name}",
    "max_withdrawal_amount": "Maksimum çekim tutarı {num} {coin_name}",
    "balance_not_enough": "Bu çekim için yeterli bakiyeniz yok.",
    "Numberofgroups": "Grup sayısı: {now}/{limit}",
    "Withdraw_success": "Çekim başarılı",
    "allProfit": "Toplam kazanç",
    "AnnualProfit": "Yıllık kazanç",
    "ScanWallet": "Cüzdanı Tara",
    "wallet_check": "cüzdan_kontrol",
    "Found": "Bulundu",
    "ScanSpeed": "Tarama hızı",
    "MyComputingPower": "Hesaplama",
    "Scanning": "Taramada!",
    "WithdrawDetail": "Para çekme ayrıntıları",
    "ScanSuccess": "Tarama başarı oranınız arttı!",
    "TaskDescription": "Görevleri tamamlayarak tarama başarı oranınızı artırın!",
    "InitializingMiningSystem": "Tarama sistemi başlatılıyor...",
    "NoWithdrawalRecord": "Çekim kaydı yok",
    "Invite": "Gerekli davetiyeler",
    "Free": "Ücretsiz",
    "Confirm": "Onayla",
    "RefreshTasks": "Görevleri yenile",
    "NumberofGroups": "Grup sayısı: {now}/{limit}",
    "SendMessage": "Mesaj gönder",
    "NumberofShares": "Paylaşım sayısı: {now}/{limit}",
    "NumberofTasks": "Görev sayısı: {now}/{limit}",
    "CompleteTask": "Görevi tamamla",
    "Accelerated": "Hızlandırılmış",
    "Accelerated_withdrawals_success": "Hızlandırılmış çekimler başarıyla",
    "GoBuy": "Git Al",
    "SpeedUpScan": "Hızı Arttır",
    "Earnings": "Kazanımlar",
    "learnMore": "Daha fazla bilgi edin",
    "claimSuccess": "Ödül başarıyla alındı",
    "claimFailed": "Ödül alınamadı, lütfen tekrar deneyin",
    "noDividends": "Alınacak temettü yok",
    "dividendsInfoFallback": "Arkadaşları davet et, yönlendirme ödülleri kazan"
}};